import {isNumber} from "utils/IsNumber.js"

export default superclass => class extends superclass {

    operationsMap = {};

    registerOperations(domain, operations) {
        this.operationsMap[domain] = operations;
    }

    onOperation(domain, operation) {
        let operations = this.operationsMap[domain];
        if (!operations) {
            // there are no operations for this domain
            return;
        }

        let tokens = operation.split(" ");
        let name = tokens[0];
        let args = tokens.slice(1).map(
            x => isNumber(x) ? parseFloat(x) : x);

        let fn = operations[name];
        if (!fn) {
            // there is no operation with that name
            return;
        }

        // call the operation function, passing in this object and the arguments
        fn(this, ...args);
    }
}
